module.exports = __webpack_public_path__ + "img/black-btn.a0a4b5b2.svg";